// extracted by mini-css-extract-plugin
export default {"container":"src-constrains-Import-css-module__container--5MznS"};